import './cookie'
import './icon'
import './device'

export function printContent(id){
    let restorepage = document.body.innerHTML;
    let printcontent = document.getElementById(el).innerHTML;
    document.body.innerHTML = printcontent;
    window.print();
    document.body.innerHTML = restorepage;
}

export function secondsToHms(d) {
    d = Number(d);
    var h = Math.floor(d / 3600);
    var m = Math.floor(d % 3600 / 60);
    var s = Math.floor(d % 3600 % 60);

    var hDisplay = h > 0 ? h + (h == 1 ? " hour, " : " hours, ") : "";
    var mDisplay = m > 0 ? m + (m == 1 ? " minute, " : " minutes, ") : "";
    var sDisplay = s > 0 ? s + (s == 1 ? " second" : " seconds") : "";
    return hDisplay + mDisplay + sDisplay;
}

export function getReadTime(selector) {
    let numberOfWords = selector.wordCounter()
    let wordsPerMinute = 230;
    let totalSeconds = numberOfWords / wordsPerMinute / 60
    return secondsToHms(totalSeconds);
}

export function isEmpty(obj) {
    for(var key in obj) {
        if(obj.hasOwnProperty(key))
            return false;
    }
    return true;
}

export function isValidSelector(selector) {
    if (typeof(selector) !== 'string') {
        return false;
    }
    try {
        let element = $(selector);
    } catch(error) {
        return false;
    }
    return true;
}
